module.exports = __webpack_public_path__ + "e1f20bda5d9d404b39209d8a25950142.svg";